// -- External libraries
import { splitProps } from 'solid-js'
import { Dynamic } from 'solid-js/web'

import { useButtonAtomComponentController } from './button-atom-component-controller.js'
import './button-atom-component.scss'

/**
 * The design system's button.
 *
 * Given an `href` it renders an ANCHOR carrying the same classes, because a control whose whole job
 * is to go somewhere has to work without JavaScript: the footer's "Learn More" was a `<button>` with
 * a `window.open()` handler, and the footer is `renderToString`-ed onto every prerendered landing
 * page and never hydrated there, so it shipped inert on 96 static pages. Every existing caller
 * passes no `href` and still renders exactly the `<button>` it rendered before.
 * [doc: verifier finding 3]
 */
export default function ButtonAtomComponent (props) {
    const {
        mergedProps,
        variantClass,
    } = useButtonAtomComponentController(props)
    const requiredAttributes = ['children']
    const [
        requestAttributes,
        styles,
        attributes,
    ] = splitProps(mergedProps, requiredAttributes, ['class', 'variant'])

    const rootClasses = () => [
        'button-atom-component',
        variantClass(),
        styles.class,
    ].filter(Boolean).join(' ')

    return (
        <Dynamic component={attributes.href ? 'a' : 'button'} class={rootClasses()} {...attributes}>
            {requestAttributes.children}
        </Dynamic>
    )
}
